export default __webpack_public_path__ + "static/media/ic_goerli_24.a8bc2855.svg";